module.exports = __webpack_public_path__ + "img/图片19.8b7fb583.png";